<template>
  <RouterLink
      data-test="logo"
      :class="{'mr-6': this.$vuetify.breakpoint.mdAndUp}"
      :to="logoRedirectPath"
  >
    <slot>
      <img
          :alt="$t('imageAlt.companyLogo')"
          class="img"
          :class="{ 'mobile': $vuetify.breakpoint.xs }"
          :src="getIsStrapiLogo ? logo.url : require('@slg/web-customer-shared/src/assets/img/logo.svg')"
      >
    </slot>
  </RouterLink>
</template>
<script lang="ts">
export default {
  name: 'TheHeaderIcon',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  logo: {
    type: Object,
    default: null,
  },
  logoRedirectPath: {
    type: Object,
    default: () => ({}),
  },
});

const getIsStrapiLogo = computed(() => {
  if (!props.logo) {
    return false;
  }
  return (props.logo as any)?.url;
});
</script>

<style scoped lang="scss">
.img {
  max-height: 52px;

  &.mobile {
    max-width: 88px;
    max-height: unset;
  }
}
</style>
